export enum ReservationType {
  NOT_SET = 0,
  REQUEST = 1,
  RESERVATION = 2,
  NEWSLETTER = 3,
  CONTACT_FORM = 4,
  DEPOSIT_PAYMENT = 5,
}
